import React from 'react'
import classNames from 'classnames'
import { isNil } from 'lodash'
import { NavLink } from 'react-router-dom'

import './Menu.scss'

/**
 * @import import { Menu } from '@/components/navigation/Menu'
 * @param {object} props
 * @param {Array<object>} [props.items] Tabs with accessor, label, and optional icon, badge, badgeProps, active, onClick, dataTestId, or to and isActive for router links
 * @param {'pill'|'bar'} [props.menuStyle] pill renders rounded items with an active background; bar runs the divider across the full menu width
 * @param {string} [props.className] Additional classes on the nav element
 */
export const Menu = ({ items = [], className, menuStyle, ...props }) => {
  return (
    <nav
      className={classNames('tab-menu', className, {
        'tab-menu-pill': menuStyle === 'pill',
        'tab-menu-bar': menuStyle === 'bar',
      })}
      {...props}
    >
      {items.map((item) => {
        const content = (
          <>
            {item.icon}
            {item.label}
            {!isNil(item.badge) && (
              // The leading space keeps the accessible name readable ("Inbox 5",
              // not "Inbox5"); flex layout ignores the whitespace-only text node.
              <>
                {' '}
                <span
                  data-testid="tab-count"
                  {...item.badgeProps}
                  className={classNames('tab-count', item.badgeProps?.className)}
                >
                  {item.badge}
                </span>
              </>
            )}
          </>
        )

        if (item.to) {
          return (
            <NavLink
              key={item.accessor}
              to={item.to}
              isActive={item.isActive}
              activeClassName="active"
              className="tab-menu-item"
              data-testid={item.dataTestId}
            >
              {content}
            </NavLink>
          )
        }

        return (
          <button
            key={item.accessor}
            type="button"
            className={classNames('tab-menu-item', { active: item.active })}
            onClick={item.onClick}
            aria-current={item.active ? 'true' : undefined}
            data-testid={item.dataTestId}
          >
            {content}
          </button>
        )
      })}
    </nav>
  )
}
